import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { toast } from 'react-toastify';
import { getToast } from '../../../utils/toastConfig';

function ModalDeleteManufacturers(props) {
    const {
        manufacturerModalDeleteString,
        manufacturerNameStr,
        manufacturerDescriptionStr,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    const deleteManufacturerId = localStorage.getItem("manufacturerIdToDelete");
    const deleteManufacturerName = localStorage.getItem("manufacturerNameToDelete");
    const deleteManufacturerDescription = localStorage.getItem("manufacturerDescriptionToDelete");
    
    const deleteManufacturer = async () => {
        try {
            await customAxios
            .patch(`${GlobalVariables.getURL()}manufacturers/update/${deleteManufacturerId}`,{
              is_active: 2,
            }, {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token"),
              },
            })
            hideS()
        } catch (error) {
            console.log("🚀 ~ manageManufacturerUpdate ~ error:", error)
        }
    } 
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Fabricante eliminado exitosamente en la base de datos.' });
        props.getManufacturers();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {manufacturerModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{manufacturerNameStr}:</strong> {deleteManufacturerName}</span><br />
                <span className='delete-info'><strong>{manufacturerDescriptionStr}:</strong> {deleteManufacturerDescription}</span><br />
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteManufacturer()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDeleteManufacturers;